import { createApp as _createApp } from 'vue';
import { createI18n } from 'utils/i18n';
import SvgIcon from "components/base/svgicon";

export const createApp = (app, props) => {
  const i18n = createI18n();
  return _createApp(app, props).use(i18n).component('svgicon', SvgIcon);
};
